import React from 'react';
import { Grid } from '@wegroup/design-system';
import { FlowsQuestionGroup } from '../../../../../types/FlowsTypes';
import { getInputConfig } from '../../../../input/inputConfig';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import { hardcodedCompanyScanConfig } from '../../config/inputComponentsConfig';
import HardcodedQuestionPicker from './HardcodedQuestionPicker';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import QuestionGroupQuestion from './QuestionGroupQuestion';
import { compareProps } from '../../../../../../../tarifications/src/legacy/services/proFlowService';
import useListenForScroll from './hooks/useListenForScroll';

interface Props {
  group: FlowsQuestionGroup;
}

const QuestionGroupWrapper: React.FC<
  React.PropsWithChildren<Props & UseFormReturn<FieldValues>>
> = ({ group }) => {
  useListenForScroll(group);
  const { flowId } = useFlowsRouteParams();

  return (
    <Grid gridRowGap="3" gridTemplateColumns="repeat(2,1fr)" w="100%">
      {group.questions.map((question) => {
        if (hardcodedCompanyScanConfig.fullyHardcodedIds[question.id])
          return <HardcodedQuestionPicker question={question} />;

        const flowInputConfig = getInputConfig(flowId || '');
        const inputType = question.rules.hidden
          ? 'HIDDEN'
          : question.rules.input_type;

        const { styling, config, gridConfig } =
          flowInputConfig[inputType] || {};

        const hardcodedFullWidth =
          hardcodedCompanyScanConfig.fullwidthIds[question.id];

        const isFullWidth = gridConfig?.isFullWidth || hardcodedFullWidth;

        return (
          <QuestionGroupQuestion
            key={question.id}
            question={question}
            isTitleHidden={config?.isTitleHidden}
            isFullWidth={isFullWidth}
            styling={styling}
          />
        );
      })}
    </Grid>
  );
};

export default React.memo(
  QuestionGroupWrapper,
  (prevProps, nextProps) =>
    prevProps.formState.isDirty === nextProps.formState.isDirty &&
    compareProps(prevProps.group, nextProps.group),
);
